import pc from '../src/components/pc/locales/zh-CN';
import mobile from '../src/components/mobile/locales/zh-CN';
export default {
    pc,
    mobile
};
